/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { $, fd, td, uid } from '../theme';
import Ic from '../Icon';

const CATEGORIES = ['Repairs','Insurance','Property Tax','Mortgage','Utilities','Landscaping','Management Fees','Other'];

const CAT_COLORS = {
  Repairs: 'bgo', Insurance: 'bbl', 'Property Tax': 'by',
  Mortgage: 'br', Utilities: 'bbl', Landscaping: 'bg',
  'Management Fees': 'bo', Other: 'b',
};

export default function ExpenseTracker({ expenses = [], onAdd, onDelete }) {
  const [showAdd,    setShowAdd]    = useState(false);
  const [filterCat,  setFilterCat]  = useState('All');
  const [saving,     setSaving]     = useState(false);
  const [form, setForm] = useState({ category: 'Repairs', description: '', amount: '', expense_date: td(), property_name: '' });

  const filtered   = filterCat === 'All' ? expenses : expenses.filter(e => (e.category || e.cat) === filterCat);
  const total      = expenses.reduce((s, e) => s + (e.amount || e.amt || 0), 0);
  const thisMonth  = expenses
    .filter(e => (e.expense_date || e.date || '').slice(0, 7) === td().slice(0, 7))
    .reduce((s, e) => s + (e.amount || e.amt || 0), 0);

  const byCategory = CATEGORIES.map(c => ({
    cat: c,
    amt: expenses.filter(e => (e.category || e.cat) === c).reduce((s, e) => s + (e.amount || e.amt || 0), 0),
  })).filter(x => x.amt > 0).sort((a, b) => b.amt - a.amt);

  const addExpense = async () => {
    if (!form.description || !form.amount) return;
    setSaving(true);
    if (onAdd) {
      await onAdd({ ...form, amount: parseFloat(form.amount) });
    }
    setForm({ category: 'Repairs', description: '', amount: '', expense_date: td(), property_name: '' });
    setShowAdd(false);
    setSaving(false);
  };

  const deleteExpense = async id => {
    if (onDelete) await onDelete(id);
  };

  return (
    <div>
      <div className="sg3" style={{ gridTemplateColumns:'repeat(3,1fr)' }}>
        <div className="st">
          <div className="stb" style={{ background:'linear-gradient(90deg,#16a34a,#4ade80)' }}/>
          <small>Total Expenses</small>
          <div className="stv">{$(total)}</div>
          <div className="sts">{expenses.length} transactions</div>
        </div>
        <div className="st">
          <div className="stb" style={{ background:'linear-gradient(90deg,#58a6ff,#79c0ff)' }}/>
          <small>This Month</small>
          <div className="stv">{$(thisMonth)}</div>
          <div className="sts">Current period</div>
        </div>
        <div className="st">
          <div className="stb" style={{ background:'linear-gradient(90deg,#f97316,#fb923c)' }}/>
          <small>Top Category</small>
          <div className="stv" style={{ fontSize:16 }}>{byCategory[0]?.cat || '—'}</div>
          <div className="sts">{byCategory[0] ? $(byCategory[0].amt) : '$0'}</div>
        </div>
      </div>

      {byCategory.length > 0 && (
        <div className="card" style={{ marginBottom:16 }}>
          <div className="card-hd"><h3>By Category</h3></div>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            {byCategory.map(x => (
              <div key={x.cat} style={{ display:'flex', alignItems:'center', gap:6, background:'#21262d', borderRadius:8, padding:'6px 12px' }}>
                <span style={{ fontSize:12, color:'#8b949e' }}>{x.cat}</span>
                <span style={{ fontSize:13, fontWeight:700, color:'#fff' }}>{$(x.amt)}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-hd">
          <h3>Expenses</h3>
          <button className="btn btn-g" style={{ padding:'6px 14px', fontSize:12 }} onClick={() => setShowAdd(true)}>
            <Ic n="plus" s={13}/> Add Expense
          </button>
        </div>
        <div className="tabs">
          {['All', ...CATEGORIES].map(c => (
            <button key={c} className={`tab${filterCat===c?' tab-on':''}`} onClick={() => setFilterCat(c)}>{c}</button>
          ))}
        </div>
        {filtered.length === 0 ? (
          <div style={{ textAlign:'center', padding:'32px', color:'#484f58' }}>
            <Ic n="receipt" s={32} c="#484f58"/>
            <div style={{ marginTop:10, fontSize:13 }}>No expenses recorded{onAdd ? '' : ' — connect your account to add expenses'}</div>
          </div>
        ) : (
          <div className="tw">
            <table>
              <thead>
                <tr>
                  <th>Description</th><th>Category</th><th>Property</th>
                  <th>Date</th><th style={{ textAlign:'right' }}>Amount</th><th/>
                </tr>
              </thead>
              <tbody>
                {filtered.map(e => (
                  <tr key={e.id}>
                    <td style={{ color:'#f5f0e8', fontWeight:500 }}>{e.description || e.desc}</td>
                    <td><span className={`b ${CAT_COLORS[e.category||e.cat]||'b'}`}>{e.category || e.cat}</span></td>
                    <td style={{ color:'#8b949e', fontSize:12 }}>{e.property_name || e.prop || '—'}</td>
                    <td style={{ color:'#8b949e', fontSize:12 }}>{fd(e.expense_date || e.date)}</td>
                    <td style={{ textAlign:'right', fontWeight:700, color:'#f85149' }}>{$(e.amount || e.amt)}</td>
                    <td>
                      {onDelete && (
                        <button className="btn btn-gh" style={{ padding:'4px 8px', fontSize:11 }} onClick={() => deleteExpense(e.id)}>
                          <Ic n="x" s={12}/>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showAdd && (
        <div className="mov" onClick={e => e.target === e.currentTarget && setShowAdd(false)}>
          <div className="modal">
            <div className="mhd">
              <h2>Add Expense</h2>
              <button className="btn btn-gh" style={{ padding:'5px 9px' }} onClick={() => setShowAdd(false)}><Ic n="x" s={15}/></button>
            </div>
            <div className="mbdy">
              <div className="fg">
                <div className="fi fi-f">
                  <label>Description</label>
                  <input value={form.description} onChange={e => setForm(p => ({...p, description: e.target.value}))} placeholder="e.g. HVAC repair" autoFocus/>
                </div>
                <div className="fi">
                  <label>Category</label>
                  <select value={form.category} onChange={e => setForm(p => ({...p, category: e.target.value}))}>
                    {CATEGORIES.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div className="fi">
                  <label>Amount ($)</label>
                  <input type="number" value={form.amount} onChange={e => setForm(p => ({...p, amount: e.target.value}))} placeholder="0.00"/>
                </div>
                <div className="fi">
                  <label>Date</label>
                  <input type="date" value={form.expense_date} onChange={e => setForm(p => ({...p, expense_date: e.target.value}))}/>
                </div>
                <div className="fi">
                  <label>Property (optional)</label>
                  <input value={form.property_name} onChange={e => setForm(p => ({...p, property_name: e.target.value}))} placeholder="e.g. Elm Ridge"/>
                </div>
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:12 }}>
                <button className="btn btn-gh" onClick={() => setShowAdd(false)}>Cancel</button>
                <button className="btn btn-g" onClick={addExpense} disabled={!form.description || !form.amount || saving}>
                  <Ic n="plus" s={14}/>{saving ? 'Saving...' : 'Add Expense'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
